import {
  BiBuildingHouse,
  BiFullscreen,
  BiHomeAlt,
  BiShieldAlt2,
} from "react-icons/bi";
import {
  FaPaintRoller,
} from "react-icons/fa";
import { FiHeadphones } from "react-icons/fi";
import { BiWater, BiSpa, BiHotTub, BiBrush } from "react-icons/bi";
import { MdHotTub } from "react-icons/md";
// import {    BiWater, BiSpa, BiHotTub, BiBrush } from "react-icons/bi";
import { MdWaterfallChart } from "react-icons/md";
// =============== home section data start ======//
import {   BiBath,  } from "react-icons/bi";
import { MdSpa, } from "react-icons/md";
import { GiWaterFountain } from "react-icons/gi";
import { FaFilter } from "react-icons/fa";
import { LuConstruction } from "react-icons/lu";
import { MdOutlineFilterAlt } from "react-icons/md";
export const focus = [
  {
    id: 1,
    name: "Swimming Pools",
    icon: <BiWater />,
    text: "Dive into excellence with our innovative swimming pool designs and solutions, perfect for residential, commercial, and competition-grade pools.",
  },
  {
    id: 2,
    name: "Fountain",
    icon: <GiWaterFountain />,
    text: "Enhance your spaces with our stunning fountain designs, combining elegance and functionality for homes and public spaces.",
  },
  {
    id: 3,
    name: "Water Features",
    icon: <MdSpa />,
    text: "Bring tranquility to your environment with our bespoke water features, crafted to complement both modern and natural settings.",
  },
  {
    id: 4,
    name: "Steam Baths",
    icon: <BiBath />,
    text: "Experience ultimate relaxation with our premium steam bath solutions, tailored to rejuvenate your body and mind.",
  },
  {
    id: 5,
    name: "Jacuzzi",
    icon: <MdHotTub />,
    text: "Elevate your wellness journey with our luxurious Jacuzzis, engineered for unmatched comfort and hydrotherapy benefits.",
  },
  {
    id: 6,
    name: "Pool Care & Maintenance",
    icon: <BiBrush />,
    text: "Ensure your pool stays in pristine condition year-round with our expert pool care products and maintenance services.",
  },
];

export const categories = [
  {
    id: 1,
    name: "Private Swimming Pools",
    image: "/images/home/categorey/categorey1.jpg",
    description: "Designed for personal enjoyment, private swimming pools provide a luxurious and serene experience for homeowners."
  },
  {
    id: 2,
    name: "Commercial Swimming Pools",
    image: "/images/home/categorey/categorey2.jpg",
    description: "Expertly crafted pools for hotels, resorts, and recreational centers, combining functionality with sophisticated design."
  },
  {
    id: 3,
    name: "Recreational Swimming Pools",
    image: "/images/home/categorey/categorey3.jpg",
    description: "Perfect for public spaces, these pools are part of larger leisure facilities and offer fun for all age groups."
  },
  {
    id: 4,
    name: "Competition Swimming Pools",
    image: "/images/home/categorey/categorey4.jpg",
    description: "Engineered for athletes, these pools are designed to meet international standards, offering optimal conditions for competitive events."
  },
  {
    id: 5,
    name: "Vanishing Edge Pools",
    image: "/images/home/categorey/categorey5.jpg",
    description: "A visually stunning design that creates the illusion of water extending to the horizon, ideal for scenic locations."
  },
  {
    id: 6,
    name: "Overflow Type Swimming Pools",
    image: "/images/home/categorey/categorey6.jpg",
    description: "Elegant perimeter-overflow pools with a sleek design where water flows seamlessly over all edges."
  },
  {
    id: 7,
    name: "Skimmer Type Swimming Pools",
    image: "/images/home/categorey/categorey7.jpg",
    description: "Efficiently designed pools that use skimmers to maintain clean and clear water surfaces."
  },
  {
    id: 8,
    name: "Readymade Swimming Pools",
    image: "/images/home/categorey/categorey8.jpg",
    description: "Quick and customizable solutions for portable and easily installed swimming pools."
  }
];


// import { FaPaintRoller } from "react-icons/fa";
// import { MdWaterfallChart } from "react-icons/md";

export const services = [
  {
    id: 1,
    name: "Turnkey Projects",
    icon: <BiBuildingHouse />,
    text: [
      "End-to-end solutions for complex construction and operational challenges.",
      "Expert advisory and practical implementation for construction projects.",
      "Streamlined processes for on-time and efficient project completion.",
    ],
  },
  {
    id: 2,
    name: "Pool Construction",
    icon: <LuConstruction />,
    text: [
      "Custom-built pools using advanced techniques and premium materials.",
      "Designed for both residential and commercial applications.",
      "Focus on durability, aesthetic appeal, and functionality.",
    ],
  },
  {
    id: 3,
    name: "Consultancy",
    icon: <BiFullscreen />,
    text: [
      "Expert guidance in engineering and facility construction.",
      "Tailored solutions for design optimization and project success.",
      "Decades of experience to enhance project outcomes.",
    ],
  },
  {
    id: 8,
    name: "Artificial Waterfalls",
    icon: <MdWaterfallChart />,
    text: [
      "Add natural beauty to your property with expertly crafted artificial waterfalls.",
      "Designed for residential, commercial, and public spaces.",
      "Focus on aesthetics, soundscaping, and seamless integration with your surroundings.",
    ],
  },
  {
    id: 9,
    name: "Fountains",
    icon: <BiWater />,
    text: [
      "Create stunning focal points with our elegant and customizable fountain designs.",
      "Perfect for gardens, courtyards, and public spaces.",
      "Combines functionality with artistry for lasting impressions.",
    ],
  },
  {
    id: 4,
    name: "Renovation Services",
    icon: <BiHomeAlt />,
    text: [
      "Transform existing spaces with innovative renovation solutions.",
      "Focus on enhancing aesthetics and functionality.",
      "Cost-effective and efficient renovation plans tailored to your needs.",
    ],
  },
  {
    id: 5,
    name: "Annual Maintenance Contracts (AMC)",
    icon: <FiHeadphones />,
    text: [
      "Comprehensive support for regular maintenance and operations.",
      "Customizable contracts to meet diverse client requirements.",
      "Ensure seamless functionality with proactive maintenance.",
    ],
  },
  {
    id: 6,
    name: "Chemicals & Spare Parts",
    icon: <FaPaintRoller />,
    text: [
      "Wide range of chemicals and spare parts for water treatment systems.",
      "Eco-friendly solutions designed for efficiency and sustainability.",
      "High-quality materials for reliable and long-lasting operations.",
    ],
  },
  {
    id: 7,
    name: "Architectural Pool Design",
    icon: <BiFullscreen />,
    text: [
      "Creative pool designs that integrate seamlessly with your property's architecture.",
      "Focus on visual appeal and practical functionality.",
      "Customized designs tailored to your preferences and landscape.",
    ],
  },
 
  {
    id: 10,
    name: "Pool Security Systems",
    icon: <BiShieldAlt2 />,
    text: [
      "Enhance safety with advanced pool security systems.",
      "Includes features like alarms, covers, and fencing.",
      "Designed for both residential and commercial spaces.",
    ],
  },
  {
    id: 11,
    name: "Pool Upgrades",
    icon: <BiHomeAlt />,
    text: [
      "Modernize pools with energy-efficient features and aesthetic enhancements.",
      "Customizable upgrades to suit individual preferences.",
      "Improve functionality with cutting-edge technology.",
    ],
  },
  {
    id: 12,
    name: "Water Treatment & Filtration",
    icon: <MdOutlineFilterAlt />,
    text: [
      "Advanced water treatment solutions to maintain water clarity and hygiene.",
      "Eco-friendly filtration systems to meet environmental standards.",
      "Ensure compliance with safety and quality regulations.",
    ],
  },

];


// =============== home section data ENd ======//


// Gallery section start ======================
export const galleryImages = Array.from({ length: 102 }, (_, index) => ({
  id: 96 - index, // This will give you IDs from 96 to 1
  image: `/images/gallery/gal${102 - index}.jpg`, // This will give you image paths from gal96.jpg to gal1.jpg
}));

// export const galleryImages = Array.from({ length: 102 }, (_, index) => ({
//   id: 96 - index,
//   image: `/images/gallery/gal${102 - index}.jpg`,
// }));
// Gallery section end ======================


// Product section start ======================
// Product section start ======================

// List of product names
const productNames = [
  "Side Mount Filter",
  "Commercial Filter",
  "Top Mount Filter",
  "Trolley Mount",
  "Cartridge",
  "Heavy Duty Pump",
  "S Series Pump",
  "Heat Pump",
  "Cool White Light",
  "LED Light",
  "SS Ladder",
  "Tiles",
  "Skimmers",
  "Portable Pool",
  "Hose Pipe",
  "Vacuum Machine",
  "Brush",
  "Section Skimmer",
  "Card Brush",
  "SS Vacuum",
  "Telescopic Handle",
  "Overflow Grating",
  "Sand Filter",
  "UV Sterilizer",
  "Waterfall Spout",
  "pH Testing Kit",
  "Pool Greetings Sign",
  "Floor Inlet Nozzle",
 
];


// Generate product objects dynamically
export const productsImages = productNames.map((name, index) => ({
  id: index + 1,
  name,
  image: `/images/products/${index + 1}.jpg`, // Image path based on index
}));



// export const productsImages = [
//   {
//     id: 1,
//     name: "Sand Filter Side Mount",
//     // role: "Backend  engineer",
//    image: "/images/products/Sand Filter Side Mount.jpg",
//   },
//   {
//     id: 2,
//     name: "Trolley mount Filteration",
//     // role: "Backend  engineer",
//    image: "/images/products/Moving Filteration plant.jpg",
//   },
//   {
//     id: 1,
//     name: "Commercial Sand Filter",
//     // role: "Backend  engineer",
//    image: "/images/products/Commercial Sand Filter.jpg",
//   },
//   {
//     id: 1,
//     name: "Cartridge Filter Austin",
//     // role: "Backend  engineer",
//    image: "/images/products/Cartridge Filter Austin.jpg",
//   },
//   {
//     id: 1,
//     name: "Sand Filter Top Mount",
//     // role: "Backend  engineer",
//    image: "/images/products/Sand Filter Top Mount.jpg",
//   },
//   {
//     id: 1,
//     name: "Heavy  duty  Pump",
//     // role: "Backend  engineer",
//    image: "/images/products/Motor Pump.jpg",
//   },

// ];

// Product section end ======================


// other pr[duct srta 

export const otherProducts = [
  {
    id: 1,
    name: "Ethan Hunt",
    role: "Backend  engineer",
   image: "/images/other-products/other-product1.jpg",
  },
  {
    id: 2,
    name: "Ethan Hunt",
    role: "Backend  engineer",
    image: "/images/other-products/other-product2.jpg",
  },
  {
    id: 3,
    name: "Raven Kent",
    role: "UI Designer",
    image: "/images/other-products/other-product3.jpg",
  },
  {
    id: 4,
    name: "John Doe",
    role: "Web developer",
    image: "/images/other-products/other-product4.jpg",
  },
  {
    id: 5,
    name: "John Doe",
    role: "Web developer",
    image: "/images/other-products/other-product5.jpg",
  },
  {
    id: 6,
    name: "Raven Kent",
    role: "UI Designer",
    image: "/images/other-products/other-product6.jpg",
  },
  {
    id: 7,
    name: "Ethan Hunt",
    role: "Backend  engineer",
    image: "/images/other-products/other-product7.jpg",
  },
  {
    id: 8,
    name: "Wabz Braize",
    role: "Front-end developer",
    image: "/images/other-products/other-product8.jpg",
  },
];
// other priduct end

// == Premium Work Start


export const feeds = [
  {
    id: 1,
    title: "Premium Swimming Pool Designs",
    image: "/images/premium-works/premium-works1.jpg",
    category: "Premium Works",
    description:
      "Explore our luxury swimming pool designs tailored to fit every aesthetic. From infinity pools to custom shapes, we create the ultimate relaxation experience.",
  },
  {
    id: 2,
    title: "Steam Rooms for Modern Homes",
    image: "/images/premium-works/steem.webp",
    category: "Steam",
    description:
      "Discover the health benefits of having a private steam room. Learn how our modular steam rooms combine comfort, durability, and design.",
  },
  {
    id: 3,
    title: "Sauna Solutions for Wellness",
    image: "/images/premium-works/Sauna.jpg",
    category: "Sauna",
    description:
      "Our Finnish-inspired saunas bring the ultimate relaxation experience to your home or spa, with eco-friendly options and customizable designs.",
  },
  {
    id: 4,
    title: "Relaxing Jacuzzi Installations",
    image: "/images/premium-works/Jacuzzi.jpg",
    category: "Jacuzzi",
    description:
      "Indulge in luxury with our premium jacuzzi installations. Perfect for home and professional use, with customizable features for ultimate comfort.",
  },
  {
    id: 5,
    title: "Elegant Water Fountains",
    image: "/images/premium-works/Fountain.jpg",
    category: "Fountain",
    description:
      "Transform your space with our stunning water fountains. Perfect for indoor and outdoor environments, combining beauty and tranquility.",
  },
  {
    id: 6,
    title: "Playground Pools for Children",
    image: "/images/premium-works/Playground.jpeg",
    category: "Playground Equipment",
    description:
      "Our vibrant playground pools are designed for fun and safety, offering endless entertainment for children of all ages.",
  },
  // {
  //   id: 7,
  //   title: "Hydrotherapy Pool Benefits",
  //   image: "/images/blog/hydrotherapy.jpg",
  //   category: "Swimming Pools",
  //   description:
  //     "Experience the therapeutic benefits of hydrotherapy pools. Designed for clinics, wellness centers, and homes, with customizable configurations.",
  // },
  // {
  //   id: 8,
  //   title: "Innovative Infinity Pools",
  //   image: "/images/blog/infinity-pool.jpg",
  //   category: "Swimming Pools",
  //   description:
  //     "Discover the elegance of infinity pools. Perfect for modern homes, these pools blend seamlessly into the landscape for stunning visuals.",
  // },
  // {
  //   id: 9,
  //   title: "Eco-Friendly Pool Solutions",
  //   image: "/images/blog/eco-friendly-pool.jpg",
  //   category: "Swimming Pools",
  //   description:
  //     "Our eco-friendly swimming pools combine sustainability with luxury. Save energy while enjoying a serene aquatic environment.",
  // },
  // {
  //   id: 10,
  //   title: "Custom Pool Designs",
  //   image: "/images/blog/custom-pool.jpg",
  //   category: "Swimming Pools",
  //   description:
  //     "Tailored swimming pool designs to suit your unique preferences. From materials to shapes, we bring your dream pool to life.",
  // },
];
// == Premium Work End


// faqs start

export const faqs = [
  {
    id: 1,
    question: "What kind of pools do you design and install?",
    response:
      "We specialize in designing and installing indoor and outdoor reinforced concrete luxury swimming pools with tiled finishes. We offer poured-in-place concrete or unitary shells, along with various alternatives to ordinary tiles.",
  },
  {
    id: 2,
    question: "Who are your main customers?",
    response:
      "Our main customers include private clients, schools, hotels, builders, pool contractors, and architects. We also specialize in mechanical services for indoor and outdoor pools, advising on pool requirements, plant systems, and environmental control for indoor pools.",
  },
  {
    id: 3,
    question: "What is included in your scope of work?",
    response:
      "Our scope of work includes initial design drawings, pool specifications, layouts, profiles, plumbing, filtration, electrical, heating, ventilation, and water features. We handle shell construction, fittings installation, and equipment setup, ensuring the pool is operational before handing it over.",
  },
  {
    id: 4,
    question: "How much does a custom swimming pool cost?",
    response:
      "Since every swimming pool is uniquely designed based on customer needs, it is challenging to provide a fixed price. However, we offer free initial consultations and provide an estimate after understanding the project requirements.",
  },
  {
    id: 5,
    question: "Why should I choose you for my swimming pool design?",
    response:
      "We are specialists in swimming pool design and construction, ensuring that you receive expert guidance and services. Unlike general contractors, we offer custom designs tailored to your specific requirements, providing a seamless experience.",
  },
  {
    id: 6,
    question: "How big and deep should my pool be?",
    response:
      "A typical residential swimming pool is 12' to 20' wide and 24' to 40' long, with a depth of 3' at the shallow end and around 5' at the deep end. The dimensions depend on your intended use, budget, and property location.",
  },
  {
    id: 7,
    question: "Am I limited to swimming pool designs shown on your website?",
    response:
      "No, you are not limited to the designs or shapes displayed on our website. Our design engineers can create custom plans based on your sketches, photographs, or specific property requirements.",
  },
  {
    id: 8,
    question: "What materials do you use for swimming pool construction?",
    response:
      "We primarily use reinforced concrete for pool shells and offer a variety of finishes, including tiles, pebbles, and high-quality pool liners. Our materials are chosen for durability and aesthetics to suit different preferences and budgets.",
  },
  {
    id: 9,
    question: "Do you provide pool maintenance services?",
    response:
      "Yes, we offer comprehensive pool maintenance services, including cleaning, chemical balancing, equipment checks, and repairs. Our team ensures your pool remains in optimal condition year-round.",
  },
  {
    id: 10,
    question: "Can you install energy-efficient and eco-friendly pools?",
    response:
      "Absolutely! We specialize in eco-friendly pool designs, including energy-efficient heating systems, solar covers, and water-saving features. We prioritize sustainability without compromising on luxury.",
  },
  {
    id: 11,
    question: "How long does it take to build a swimming pool?",
    response:
      "The timeline for building a swimming pool depends on the complexity of the design, size, and additional features. Typically, it takes between 8 to 12 weeks from excavation to completion.",
  },
  {
    id: 12,
    question: "Do you provide custom water features for pools?",
    response:
      "Yes, we offer a range of custom water features, such as fountains, waterfalls, and jets. These can be tailored to enhance the aesthetics and ambiance of your swimming pool.",
  },
  {
    id: 13,
    question: "What warranties do you provide for your pools?",
    response:
      "We provide warranties on pool construction, materials, and installed equipment. The duration and terms depend on the specific project, and we ensure all details are shared upfront during the agreement phase.",
  },
  {
    id: 14,
    question: "Do you handle permits and regulations for pool construction?",
    response:
      "Yes, we assist with obtaining necessary permits and ensure compliance with local building codes and regulations. Our team takes care of the paperwork to make the process hassle-free for you.",
  },
  {
    id: 15,
    question: "What is the best location for a swimming pool on my property?",
    response:
      "The best location depends on factors like sunlight exposure, accessibility, drainage, and privacy. We provide consultations to determine the ideal placement for your pool based on your property layout and preferences.",
  },
];
// faqs end





export const testimonials = [
  {
    id: 1,
    name: "Wabz Braize",
    role: "Front-end developer",
    image: "/images/avatar.png",
    reviewText:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corporis porro ex perferendis, nulla consectetur consequuntur odio qui adipisci harum earum dolor, eius accusantium quia praesentium.",
  },
  {
    id: 2,
    name: "Ethan Hunt",
    role: "Backend engineer",
    image: "/images/avatar-1.png",
    reviewText:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corporis porro ex perferendis, nulla consectetur consequuntur odio qui adipisci harum earum dolor, eius accusantium quia praesentium.",
  },
  {
    id: 3,
    name: "Raven Kent",
    role: "UI Designer",
    image: "/images/avatar-2.png",
    reviewText:
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Corporis porro ex perferendis, nulla consectetur consequuntur odio qui adipisci harum earum dolor, eius accusantium quia praesentium.",
  },
];










